import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import IconPlan from './icons/layers-three-01.svg';
import IconFPG from './icons/shield-tick.svg';
import IconRefin from './icons/refresh-ccw-05.svg';
import IconFlexibilty from './icons/calendar-move.svg';
import IconReporting from './icons/file-check-02.svg';
import s from './index.module.scss'

const NAVIGATION = t => [
  {
    icon: IconPlan,
    label: t('navigation.plans'),
    desc: t('navigation.plans_description'),
    path: APP_LINKS.loanTermsPlans(),
  },
  {
    icon: IconFPG,
    label: t('navigation.fpg'),
    desc: t('navigation.fpg_description'),
    path: APP_LINKS.loanTermsFpg(),
  },
  {
    icon: IconRefin,
    label: t('navigation.refinancing'),
    desc: t('navigation.refinancing_description'),
    path: APP_LINKS.loanTermsRefinancing(),
  },
  {
    icon: IconFlexibilty,
    label: t('navigation.flexibility'),
    desc: t('navigation.flexibility_description'),
    path: APP_LINKS.loanTermsFlexibility(),
  },
  {
    icon: IconReporting,
    label: t('navigation.reporting_modes'),
    desc: t('navigation.reporting_modes_description'),
    path: APP_LINKS.loanTermsReportingModes(),
  },
];

export const Navigation = ({ className }) => {
  const { t } = useTranslation('loan-terms');
  const { pathname } = useLocation();
  return (
    <div className={classnames(s.items, className)}>
      {NAVIGATION(t)
        .filter(i => !pathname.includes(i.path))
        .map((item, idx) => (
          <MyLink key={idx} href={item.path} className={s.item}>
            <div className={s.item_icon}>
              <img src={item.icon} alt={item.label} width={24} height={24} />
            </div>
            <div className={classnames(s.item_title, 'f-paragraph-accent')}>{item.label}</div>
            <div className={classnames(s.item_desc, 'f-small-regular')}>{item.desc}</div>
            <div className={classnames(s.item_learn, 'f-small-accent')}>
              {t('navigation.learn_more')}
            </div>
          </MyLink>
        ))}
    </div>
  );
};